"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompositeSlice = exports.CompositeSlice = exports.CompositeSliceConfig = exports.CompositeSliceType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const common_1 = require("../../../common");
const validators_1 = require("../../../validators");
const NestableWidget_1 = require("../nestable/NestableWidget");
exports.CompositeSliceType = "Slice";
exports.CompositeSliceConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
}));
exports.CompositeSlice = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.CompositeSliceType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        description: t.string,
        icon: t.string,
        display: t.string,
        "non-repeat": t.record(common_1.WidgetKey, NestableWidget_1.NestableWidget),
        repeat: t.record(common_1.WidgetKey, NestableWidget_1.NestableWidget),
        config: exports.CompositeSliceConfig,
    }),
]));
function isCompositeSlice(slice) {
    return slice.type === "Slice";
}
exports.isCompositeSlice = isCompositeSlice;
